// In-memory session, mirroring global_100seconds_admin_frontend's
// config/Auth.jsx: the access token lives only in a module closure (never
// localStorage/sessionStorage); the refresh token is an HttpOnly cookie the
// browser holds and JS never sees. A page reload starts logged-out in memory
// and relies on silent-refresh-on-boot (see AuthContext).

export type Role = "admin" | "editor";

export interface Admin {
  public_id: string;
  username: string;
  email: string;
  display_name: string | null;
  role: Role;
  is_active: boolean;
  last_login_at: string | null;
}

let accessToken: string | null = null;
let tokenExpiresAt: number | null = null;
let admin: Admin | null = null;

export const Auth = {
  getAccessToken(): string | null {
    return accessToken;
  },
  getAdmin(): Admin | null {
    return admin;
  },
  getExpiresAt(): number | null {
    return tokenExpiresAt;
  },
  setSession(newAccessToken: string, expiresIn: number | null, newAdmin?: Admin | null): void {
    accessToken = newAccessToken;
    tokenExpiresAt = expiresIn ? Date.now() + expiresIn * 1000 : null;
    if (newAdmin) admin = newAdmin;
  },
  updateAdmin(partial: Partial<Admin>): void {
    if (admin) admin = { ...admin, ...partial };
  },
  clearSession(): void {
    accessToken = null;
    tokenExpiresAt = null;
    admin = null;
  },
};
